import { supportEmail } from '../../../../constantValues/ConstantValues';

const USER_MANUAL_URL = 'https://yemma-eu-central-1-dev-static-files.s3.eu-central-1.amazonaws.com/Yemma+user+guide.pdf';

export function AccountSettingsSupport() {
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Please take a look at the{' '}
        <a
          href={USER_MANUAL_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover:underline"
        >
          user manual
        </a>
      </p>
      <p className="text-sm text-muted-foreground">
        If you need help, contact support at{' '}
        <a
          href={`mailto:${supportEmail}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover:underline"
        >
          {supportEmail}
        </a>
      </p>
    </div>
  );
}
